"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWebinars = getWebinars;
exports.getWebinarsRequestState = getWebinarsRequestState;
exports.getWebinarsSyncEnabled = getWebinarsSyncEnabled;
exports.getWebinarsSettingsRequestState = getWebinarsSettingsRequestState;
exports.getWebinarsErrorCode = getWebinarsErrorCode;

function getWebinars(state) {
  return state.goToWebinars.webinars;
}

function getWebinarsRequestState(state) {
  return state.goToWebinars.requestState;
}

function getWebinarsSyncEnabled(state) {
  return state.goToWebinars.webinarsSyncEnabled;
}

function getWebinarsSettingsRequestState(state) {
  return state.goToWebinars.requestStateSettings;
}

function getWebinarsErrorCode(state) {
  return state.goToWebinars.errorCode;
}